import axios from 'axios';
import authToken from 'js/library/utils/API/authToken';
import cfac22 from '../cfac22';

export function processOrder(uId, orderObject, consumed) {
  return new Promise((resolve, reject) => {
    authToken(uId)
      .then((token) => {
        axios
          .post(
            `${cfac22('API_HOST_V2')}/order/processOrder`,
            {
              orderObject,
              consumed,

              /* Compõe o orderObject
                 - itemId,
                 - receiver,
                 - requestDate,
                 - requestLat,
                 - requestLon,
                 - sender,
                 - type, 
                */
            },
            { headers: { authorization: `Bearer ${token}`, 'Full-Url': window.location.href } }
          )
          .then((result) => {
            resolve(result.data.response);
          })
          .catch((error) => {
            return reject(error.response.data.error);
          });
      })
      .catch((error) => {
        reject(error);
      });
  });
}
